import React from 'react';

export function RadioOn(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.99999 12C4.99999 8.13401 8.13399 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13399 19 4.99999 15.866 4.99999 12Z"
          fill="currentColor"
        />
        {/* <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0.800003C5.8144 0.800003 0.799988 5.81441 0.799988 12C0.799988 18.1856 5.8144 23.2 12 23.2C18.1856 23.2 23.2 18.1856 23.2 12C23.2 5.81441 18.1856 0.800003 12 0.800003ZM12 3.2C16.8601 3.2 20.8 7.1399 20.8 12C20.8 16.8601 16.8601 20.8 12 20.8C7.13988 20.8 3.19999 16.8601 3.19999 12C3.19999 7.1399 7.13988 3.2 12 3.2Z"
          fill="black"
        /> */}
      </svg>
    </div>
  );
}
